<button mat-button [matMenuTriggerFor]="menu" class="user-trigger">
  <div class="user-avatar" [class.has-image]="!!userImage() && !imageErrored()">
    @if (userImage() && !imageErrored()) {
    <img [src]="userImage()!" alt="" (error)="clearImage.emit()" />
    } @else {
    <mat-icon>account_circle</mat-icon>
    }
  </div>
  <span class="user-name">{{ userDisplayName() }}</span>
  <mat-icon class="chevron">expand_more</mat-icon>
</button>
<mat-menu #menu="matMenu" class="user-dropdown" xPosition="before">
  <div class="dropdown-header" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="user-avatar large" [class.has-image]="!!userImage() && !imageErrored()">
      @if (userImage() && !imageErrored()) {
      <img [src]="userImage()!" alt="" (error)="clearImage.emit()" />
      } @else {
      <mat-icon>account_circle</mat-icon>
      }
    </div>
    <div class="dropdown-user-info">
      <strong>{{ userDisplayName() }}</strong>
      <span>{{ userEmail() }}</span>
    </div>
  </div>
  <div class="dropdown-role" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">{{ accountRoleLabel() }}</div>

  @if (showProviderMenu()) {
  <button mat-menu-item routerLink="/account/provider-status" class="primary-menu-item">
    <mat-icon>badge</mat-icon>
    <span>Provider Status</span>
  </button>
  <mat-divider />
  }

  @if (showAdminItems()) {
  <button mat-menu-item routerLink="/admin/dashboard" class="primary-menu-item">
    <mat-icon>dashboard</mat-icon>
    <span>Admin Dashboard</span>
  </button>
  <button mat-menu-item routerLink="/admin/services">
    <mat-icon>build</mat-icon>
    <span>Services</span>
  </button>
  <button mat-menu-item routerLink="/admin/jobs/overview">
    <mat-icon>assignment</mat-icon>
    <span>Jobs</span>
  </button>
  <button mat-menu-item routerLink="/admin/earnings">
    <mat-icon>trending_up</mat-icon>
    <span>Earnings</span>
  </button>
  @if (showAdminRestricted()) {
  <button mat-menu-item routerLink="/admin/users">
    <mat-icon>people</mat-icon>
    <span>Users</span>
  </button>
  <button mat-menu-item routerLink="/admin/providers">
    <mat-icon>badge</mat-icon>
    <span>Providers</span>
  </button>
  <button mat-menu-item routerLink="/admin/payouts">
    <mat-icon>payments</mat-icon>
    <span>Payouts</span>
  </button>
  <button mat-menu-item routerLink="/admin/payments/paystack-credentials">
    <mat-icon>account_balance_wallet</mat-icon>
    <span>Paystack</span>
  </button>
  @if (showAIModels()) {
  <button mat-menu-item routerLink="/admin/ai-models">
    <mat-icon>smart_toy</mat-icon>
    <span>AI Models</span>
  </button>
  }
  @if (showAIAgents()) {
  <button mat-menu-item routerLink="/admin/ai-agents">
    <mat-icon>psychology</mat-icon>
    <span>AI Agents</span>
  </button>
  }
  }
  <mat-divider />
  }

  <div class="menu-section-label" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">Account</div>
  <button mat-menu-item routerLink="/account/profile">
    <mat-icon>person</mat-icon>
    <span>Profile</span>
  </button>
  <button mat-menu-item routerLink="/account/bookings">
    <mat-icon>event_available</mat-icon>
    <span>Bookings</span>
  </button>

  <mat-divider />
  <button mat-menu-item (click)="logout.emit()" class="logout-menu-item">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
